export default __webpack_public_path__ + "static/media/net-right-background.9fa151d8.svg";